import React, { useContext, useState } from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import NtwAlert from '../NewTemplateWizard/NtwContentOptions/NtwAlert';

function DownloadFile({ open, toggle }) {
    const parentScreen = useContext(ParentScreenCtx)
    const fileData = useSelector((state) => state.treeData[parentScreen].docFiledata);
    const [alert, setAlert] = useState({ open: false,message: '',type: 'success' });
    
  
    const handleDownloadFile = () => {
      if (!fileData.blob) {
          setAlert({ open: true, message: 'No file data provided', type: 'error' });
          return;
      }
  
      try {
          let blobUrl;
  
          if (typeof fileData.blob === 'string' && fileData.blob.startsWith('data:')) {
              blobUrl = fileData.blob;
          } else {
              const isJson = typeof fileData.blob === 'object';
              const content = isJson ? JSON.stringify(fileData.blob, null, 2) : fileData.blob;
              const mimeType = isJson ? 'application/json' : 'text/html';
  
              const blob = new Blob([content], { type: mimeType });
              blobUrl = URL.createObjectURL(blob);
          }
  
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileData.fileName || 'download.json';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
  
          if (!blobUrl.startsWith('data:')) {
              URL.revokeObjectURL(blobUrl);
          }
  
          setAlert({ open: true, message: 'File downloaded successfully', type: 'success' });
          if (toggle) toggle();
      } catch (error) {
          console.error("Download error:", error);
          setAlert({ open: true, message: 'Error downloading file', type: 'error' });
      }
  };
  
    
    useEffect(() => {
     if(open) handleDownloadFile();
    },[open])
  
    return (
    <>
      <NtwAlert
        open={alert.open}
        message={alert.message}
        onClose={() => setAlert({...alert, open:false})}
        type={alert.type}
     />
    </>
  )
}

export default DownloadFile